import React, { useState } from 'react';
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';

const actionReasons = {
  card: [
    'Inappropriate Content',
    'Spam',
    'Violates Community Guidelines',
    'Art Image Issues',
    'Cardtext Issues',
  ],
  comment: [
    'Harassment',
    'Spam',
    'Hate Speech',
    'Inappropriate Content',
  ],
  user: [
    'Multiple Violations',
    'Severe Misconduct',
    'Spam Account',
    'Impersonation',
  ],
};

const banDurations = [
  { value: '1d', label: '1 Day' },
  { value: '1w', label: '1 Week' },
  { value: '1m', label: '1 Month' },
  { value: '1y', label: '1 Year' },
  { value: 'permanent', label: 'Permanent' },
];

const ModeratorActionModal = ({ show, onHide, actionType, itemId }) => {
  const [reason, setReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [banDuration, setBanDuration] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleReasonChange = (e) => {
    setReason(e.target.value);
    if (e.target.value !== 'custom') {
      setCustomReason('');
    }
  };

  const handleCustomReasonChange = (e) => {
    setCustomReason(e.target.value);
  };

  const handleBanDurationChange = (e) => {
    setBanDuration(e.target.value);
  };

  const handleSubmit = async () => {
    const finalReason = reason === 'custom' ? customReason : reason;
    
    setIsSubmitting(true);
    try {
      let endpoint;
      let payload;

      switch (actionType) {
        case 'card':
          endpoint = `/api/moderation/moderator_actions_api.php?action=${actionType}`;
          payload = { cardId: itemId, reason: finalReason };
          break;
        case 'comment':
          endpoint = `/api/moderation/moderator_actions_api.php?action=${actionType}`;
          payload = { commentId: itemId, reason: finalReason };
          break;
        case 'user':
          endpoint = `/api/moderation/moderator_actions_api.php?action=${actionType}`;
          payload = { userId: itemId, reason: finalReason, banDuration };
          break;
        default:
          throw new Error('Invalid action type');
      }

      const response = await axios.post(endpoint, payload);

      if (response.data.success) {
        alert('Action completed successfully');
        onHide();
        resetForm();
      } else {
        alert(`Failed to perform action: ${response.data.message}`);
      }
    } catch (error) {
      console.error('Error performing moderator action:', error);
      alert('An error occurred while performing the action');
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setReason('');
    setCustomReason('');
    setBanDuration('');
  };

  const getModalTitle = () => {
    switch (actionType) {
      case 'card': return 'Remove Card';
      case 'comment': return 'Remove Comment';
      case 'user': return 'Ban User';
      default: return 'Moderator Action';
    }
  };

  const isValidActionType = actionType && actionReasons.hasOwnProperty(actionType);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{getModalTitle()}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {isValidActionType ? (
        <Form>
          <Form.Group controlId="actionReason">
            <Form.Label>Reason for action:</Form.Label>
            <Form.Control
              as="select"
              value={reason}
              onChange={handleReasonChange}
              className="mb-3"
            >
              <option value="">Select a reason...</option>
              {actionReasons[actionType].map((r, index) => (
                <option key={index} value={r}>{r}</option>
              ))}
              <option value="custom">Other (please specify)</option>
            </Form.Control>
          </Form.Group>
          
          {reason === 'custom' && (
            <Form.Group controlId="customReason" className="mb-3">
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Please enter your reason here..."
                value={customReason}
                onChange={handleCustomReasonChange}
              />
            </Form.Group>
          )}

          {actionType === 'user' && (
            <Form.Group controlId="banDuration" className="mb-3">
              <Form.Label>Ban Duration:</Form.Label>
              <Form.Control
                as="select"
                value={banDuration}
                onChange={handleBanDurationChange}
              >
                <option value="">Select ban duration...</option>
                {banDurations.map((duration, index) => (
                  <option key={index} value={duration.value}>{duration.label}</option>
                ))}
              </Form.Control>
            </Form.Group>
          )}
          
          <div className="d-flex justify-content-end mt-3">
            <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>Cancel</Button>
            <Button 
              variant="danger" 
              className="ms-2" 
              onClick={handleSubmit}
              disabled={!reason || (reason === 'custom' && !customReason) || (actionType === 'user' && !banDuration) || isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Confirm Action'}
            </Button>
          </div>
        </Form>
                ) : (
                  <p>Invalid action type. Please try again.</p>
                )}
      </Modal.Body>
    </Modal>
  );
};

export default ModeratorActionModal;